import React from "react";
import { Table } from "antd";
import IntlMessages from "@iso/components/utility/intlMessages";
import { StatusTag } from "./PaymentsTable.styles";

export default function ({ dataList }) {
  const { data, pagination, loading } = dataList;

  const handleTableChange = (pagination, filters, sorter) => {
    this.fetch({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      ...filters,
    });
  };
  const renderStatus = (item) => {
    if (item === "S")
      return <StatusTag className="status-tag succeeded">succeeded</StatusTag>;
    if (item === "F")
      return <StatusTag className="status-tag failed">failed</StatusTag>;
  };
  const formatAmount = (str) => {
    str = str.toString();
    var len = str.length;
    return str.substring(0, len - 2) + "." + str.substring(len - 2);
  };

  const formatTime = (item) => {
    const hours =
      new Date(item).getHours() > 10
        ? new Date(item).getHours()
        : `0${new Date(item).getHours()}`;
    const minutes =
      new Date(item).getMinutes() > 10
        ? new Date(item).getMinutes()
        : `0${new Date(item).getMinutes()}`;
    return `${hours}:${minutes} GMT`;
  };

  return (
    <Table
      // columns={tableinfos.columns}
      dataSource={data}
      pagination={pagination}
      scroll={{ y: 500 }}
      rowKey={(record) => record.created}
      loading={loading}
      onChange={handleTableChange}
    >
      <Table.Column
        title={<IntlMessages id="page.myAccount.financialTable.amount" />}
        dataIndex="amount"
        render={(item) => `$${formatAmount(item)}`}
      />
      <Table.Column
        title={<IntlMessages id="page.myAccount.financialTable.date" />}
        dataIndex="created"
        render={(item) => new Date(item).toLocaleDateString("en-US")}
      />
      <Table.Column
        title={<IntlMessages id="page.myAccount.financialTable.time" />}
        dataIndex="created"
        render={(item) => formatTime(item)}
      />
      <Table.Column
        title={<IntlMessages id="page.myAccount.financialTable.status" />}
        dataIndex="status"
        render={(item) => renderStatus(item)}
      />
      <Table.Column
        title={<IntlMessages id="page.myAccount.financialTable.receipt" />}
        dataIndex="receipt_url"
        render={(item) =>
          item ? (
            <a href={item} rel="noopener noreferrer" target="_blank">
              Open receipt
            </a>
          ) : (
            "N/A"
          )
        }
      />
    </Table>
  );
}
